// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ToolConfigSchema } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetToolConfigSchema(): (
  toolId: string
) => Promise<ToolConfigSchema> {
  const getAPI = useGetApi();
  return useCallback(
    async (toolId) => (await getAPI()).tools.getToolConfigSchema({ toolId }),
    [getAPI]
  );
}
